module.exports = __webpack_public_path__ + "static/media/TelaSaqueReaporteES.690badef.png";